import { Helmet } from 'react-helmet-async'
import { useParams } from 'react-router-dom'
import appStoreBadge from './get_from_app_store_se.svg'
import googlePlayBadge from './google-play.png'

const APP_STORE_URL = 'https://apps.apple.com/se/app/chronos/id6472299482'
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.stagem.Chronos'

function SharedListing({ siteLogo }) {
  const { id } = useParams()
  const safeId = id || ''
  const canonicalUrl = `https://kronos.se/annons/${encodeURIComponent(safeId)}`

  return (
    <>
      <Helmet>
        <title>Öppna annonsen i Kronos</title>
        <meta
          name="description"
          content="Öppna den delade klockannonsen i Kronos-appen och kontakta säljaren."
        />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>

      <section className="min-h-[70vh] bg-[#f7f7f5] px-5 py-12 sm:px-8 sm:py-20">
        <section className="mx-auto flex max-w-2xl flex-col items-center rounded-3xl bg-white px-6 py-10 text-center shadow-sm ring-1 ring-black/5 sm:px-12 sm:py-14">
          <img src={siteLogo} alt="Kronos" className="mb-8 h-12 w-auto" />
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#6a756f]">
            Delad annons
          </p>
          <h1 className="mt-3 text-3xl font-semibold tracking-tight text-[#1f2e29] sm:text-4xl">
            Öppna annonsen i Kronos
          </h1>
          <p className="mt-4 max-w-lg text-base leading-7 text-[#65716c] sm:text-lg">
            Se bilder och detaljer om klockan och kontakta säljaren direkt i Kronos-appen.
          </p>
          <p className="mt-6 rounded-full bg-[#f1f3f1] px-4 py-2 text-sm text-[#65716c]">
            Annonsnummer <span className="font-semibold text-[#1f2e29]">{safeId}</span>
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <a href={APP_STORE_URL} aria-label="Ladda ner Kronos från App Store">
              <img src={appStoreBadge} alt="Ladda ner på App Store" className="h-12 w-auto" />
            </a>
            <a href={GOOGLE_PLAY_URL} aria-label="Ladda ner Kronos från Google Play">
              <img src={googlePlayBadge} alt="Hämta på Google Play" className="h-12 w-auto" />
            </a>
          </div>
          <p className="mt-8 text-sm text-[#7a8580]">
            När appen är installerad öppnar du länken igen för att komma till annonsen.
          </p>
        </section>
      </section>
    </>
  )
}

export default SharedListing
